<button
  mat-mini-fab
  color="accent"
  class="btn"
  [matTooltip]="'Прикрепить файл'"
  [matTooltipShowDelay]="300"
  (click)="handleSave()"
>
  <mat-icon class="btn-icon">save</mat-icon>
</button>
